import React from 'react'
import {defineMessage, useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {useHotelRoomsFilters} from 'hooks/useHotelRoomsFilters'

import {Alert} from '@vio/atlas/Alert'
import {HorizontalScroll} from '@vio/atlas/helpers/HorizontalScroll'
import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'
import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {RoomsFilterKey} from '@vio/core/src/room/business/utils/filters'

import {filtersConfig, messages} from './constants'

const titleMessage = defineMessage({
  id: 'filterMatchesWithCount',
  defaultMessage:
    'We {count, plural, =0 {found no matches} one {only found 1 match} other {only found # matches}}'
})

const ScrollWrapper = styled.div`
  margin: ${cssTheme.layout.spacing.s400} ${minus(cssTheme.layout.spacing.s400)}
    ${minus(cssTheme.layout.spacing.s400)}
    ${minus(cssTheme.layout.spacing.s400)};
  padding: 0 ${cssTheme.layout.spacing.s400};
  padding-bottom: ${cssTheme.layout.spacing.s400};
`

const VerticalDivider = styled.div`
  width: 1px;
  flex-shrink: 0;
  height: ${cssTheme.layout.spacing.s700};
  background-color: ${cssTheme.colors.content.warning.secondary};
`

export const NoFilteredRoomsResults = () => {
  const {formatMessage} = useIntl()
  const {
    activeRoomsFilters: activeFilterIds,
    toggleRoomsFilter,
    setRoomsFilters
  } = useHotelRoomsFilters()

  const activeRoomsFilters = activeFilterIds.map(filterId =>
    filtersConfig.find(({id}) => id === filterId)
  )

  const onRoomsFilterClick = (id: RoomsFilterKey) => toggleRoomsFilter(id)
  const clearFilters = () => setRoomsFilters([])

  return (
    <Alert
      title={formatMessage(titleMessage, {count: 0})}
      variant="warning"
      dataId="noFilteredRoomsResults"
    >
      <FormattedMessageWrapper
        id="adjustFiltersToSeeMoreResults"
        defaultMessage="To see more results, adjust your search criteria, remove some filters, or clear all."
      />
      <ScrollWrapper>
        <HorizontalScroll columnGap="s200" rowGap="s200">
          {activeRoomsFilters.map(filter => (
            <Pill
              key={filter.id}
              isSelected={false}
              iconEnd={<Icon name={'Close'} />}
              onClick={() => onRoomsFilterClick(filter.id)}
              dataId="noFilteredRoomsResultsFilter"
            >
              {formatMessage(messages[filter.id])}
            </Pill>
          ))}
          <VerticalDivider />
          <Pill
            iconStart={<Icon name="Trash2" />}
            onClick={clearFilters}
            dataId="noFilteredRoomsResultsClearAll"
          >
            <FormattedMessageWrapper id="clearAll" defaultMessage="Clear all" />
          </Pill>
        </HorizontalScroll>
      </ScrollWrapper>
    </Alert>
  )
}
